import { Button } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';

const VerifiedCard = () => {
    const history = useHistory();

    const onSignUp = async () => {
        history.push("/");
    };

    return <div className="right_item">
        <div className="pubheader_sec">
            <div className="pub_title">Welcome to FoodLuv</div>
            <h3 className="sub_title">Verify your account</h3>
            <div className="logo_sec"><img src="/images/login_icon.png" alt="" /></div>
        </div>
        <div className='w-full'>
            <img src="/images/verify_success.png" alt="" />
        </div>
        <div className="otp_btns">
            <Button type="primary" className='otp_signup' onClick={onSignUp}>Login Now</Button>
        </div>
    </div>
};
 export default VerifiedCard;